import React, { Component } from 'react';
import ReactSuperSelect from 'react-super-select';
import rest from 'rest';

/**
* Class Combobox
* Generic component to generate Combobox
**/
class Combobox extends Component {
  /**
  * props
  * ReactSuperSelect props
  * default : the default selected value id
  * forceSelection : to prevent empty values
  * url : url to retrieve data from server
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);
    this.state = {
      cbxProps: {
        onChange: () => {}
      }
    };
    this.onChange = this.onChange.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  /**
  * componentWillMount
  * Pre-rendering component function : loading object if it doesn't exist
  **/
  componentWillMount() {
    this.loadData();
  }

  /**
  * loadData
  * Load the data if needed
  **/
  loadData() {
    if(this.props.url) {
      rest({method: 'GET', path: this.props.url}).then(response => {
        let dataSource = { collection: [] };
        dataSource.collection = JSON.parse(response.entity);
        this.continueInit(dataSource);
      });
    } else {
      this.continueInit();
    }
  }

  /**
  * continueInit
  * Sets the combobox props
  **/
  continueInit(dataSource) {
    this.dataSource = (dataSource !== undefined) ? dataSource : this.props.dataSource;
    let state = {};
    let cbxProps = { customClass: "combobox-control", noResultsString: "Aucune donnée", placeholder: "Sélectionner...", ref: "combobox", clearSelectedValueOnDataSourceChange: true };

    for (let key in this.props) {
      if(key === "onChange") {
        cbxProps[key] = this.onChange;
      } else if(key === "onClear") {
        cbxProps[key] = this.onClear;
      } else if (key === "default") {
        const initialValue = this.getDatasourceValueForId(this.dataSource, this.props.default);
        cbxProps["initialValue"] = initialValue;
      } else if(key === "forceSelection") {
        cbxProps["clearable"] = false;
        cbxProps["deselectOnSelectedOptionClick"] = false;
      } else if(key === "url") {
        cbxProps["dataSource"] = this.dataSource;
      } else if (key === "enableSearch" && this.props.enableSearch === true) {
        cbxProps["clearSearchOnSelection"] = true;
        cbxProps["searchable"] = true;
        cbxProps["searchPlaceholder"] = "Rechercher";
      } else {
        cbxProps[key] = this.props[key];
      }
    }

    if(this.props.disabled === true) {
      cbxProps["clearable"] = false;
    }

    state.cbxProps = cbxProps;
    this.setState(state);
  }

  /**
  * getDatasourceValueForId
  * Returns the object from a dataSource for an ID
  **/
  getDatasourceValueForId(dataSource, id) {
    const idKey = (this.props.optionValueKey !== undefined) ? this.props.optionValueKey : "id";
    const initialValue = dataSource.collection.find(obj => obj[idKey] === id);
    return initialValue;
  }

  /**
  * render
  * Rendering component function : display the Combobox
  **/
  render() {
    if(this.state.cbxProps.dataSource === undefined) {
      return null;
    }

    return(
      <ReactSuperSelect {...this.state.cbxProps} />
    );
  }

  /**
  * onChange
  * Handle onChange event
  **/
  onChange(obj) {
    this.props.onChange.call(this, obj, this);
  }

  /**
  * onClear
  * Handle onClear event
  **/
  onClear(obj) {
    this.props.onClear.call(this, obj, this);
  }

  /**
  * setSearchString
  * Filters the data by label
  **/
  setSearchString(str) {
    let cbxState = this.refs.combobox.state;
    cbxState.searchString = str;
    this.refs.combobox.setState(cbxState);
  }

  /**
  * clear
  * Clear the combobox
  **/
  clear() {
    this.refs.combobox.setState({value: []});
  }

  /**
  * setValue
  * Set combobox value
  **/
  setValue(id) {
    const value = this.getDatasourceValueForId(this.dataSource, id);
    let state = this.state;
    state.cbxProps.initialValue = value;
    this.setState(state);
  }

}

export default Combobox;



// WEBPACK FOOTER //
// ./src/views/Helper/Combobox.js